module.exports = __webpack_public_path__ + "static/results-full-341318e0ad0a7a6521b83874469b84a4.mp3";